import { render, staticRenderFns } from "./PdpTextCopyTab.vue?vue&type=template&id=692ccf12&scoped=true"
import script from "./PdpTextCopyTab.vue?vue&type=script&lang=js"
export * from "./PdpTextCopyTab.vue?vue&type=script&lang=js"
import style0 from "./PdpTextCopyTab.vue?vue&type=style&index=0&id=692ccf12&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692ccf12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('692ccf12')) {
      api.createRecord('692ccf12', component.options)
    } else {
      api.reload('692ccf12', component.options)
    }
    module.hot.accept("./PdpTextCopyTab.vue?vue&type=template&id=692ccf12&scoped=true", function () {
      api.rerender('692ccf12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/pdp-tabs/PdpTextCopyTab.vue"
export default component.exports